import { PhoneOutlined, LoadingOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { useCallMerge } from "../../../hooks/useCallMerge/useCallMerge";
import style from "./callMergeButton.module.scss";

export const CallMergeButton = () => {
  const { isOpen, agents, loading, merging, handleOpen, handleClose, handleMerge } = useCallMerge();

  return (
    <>
      <button className={style.floatingBtn} onClick={handleOpen} title="Merge Call">
        <UsergroupAddOutlined  style={{ transform: "scaleX(1)" }} />
      </button>

      {isOpen && (
        <div className={style.overlay} onClick={handleClose}>
          <div className={style.modal} onClick={(e) => e.stopPropagation()}>
            <div className={style.modalHeader}>
              <span className={style.modalTitle}>Select Agent to Merge</span>
              <button className={style.closeBtn} onClick={handleClose}>✕</button>
            </div>
            <div className={style.modalBody}>
              {loading ? (
                <div className={style.loader}><LoadingOutlined /></div>
              ) : agents.length === 0 ? (
                <p className={style.noData}>No agents available</p>
              ) : (
                agents.map((agent) => (
                  <button
                    key={agent.id}
                    className={style.agentItem}
                    onClick={() => handleMerge(agent.id)}
                    disabled={!!merging}
                  >
                    <PhoneOutlined className={style.agentIcon} style={{ transform: "scaleX(-1)" }} />
                    <span>{agent.name}</span>
                    {merging === agent.id && <LoadingOutlined className={style.mergingIcon} />}
                  </button>
                ))
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
